import types from '@/vuex/documento/mutations-types'

const mutations = {
  [types.SET_DOCUMENTO]: (state, payload) => {
    state.documento = payload.documento
  },
  [types.SET_PRESENTE_CAIXA_POSTAL]: (state, payload) => {
    state.presenteCaixaPostal = payload.presenteCaixaPostal
  },
  [types.SET_RAIZ_PRESENTE_CAIXA_POSTAL]: (state, payload) => {
    state.raizPresenteCaixaPostal = payload.raizPresenteCaixaPostal
  },
  [types.SET_EMAIL_INTERESSADO]: (state, payload) => {
    state.emailInteressado = payload.emailInteressado
  },
  [types.SET_URL_CONSOLIDACAO]: (state, payload) => {
    state.consolidacaoURL = payload.consolidacaoURL
  },
  [types.SET_LISTA_CONSOLIDACOES]: (state, payload) => {
    state.listaConsolidacoes = payload.listaConsolidacoes
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/documento/mutations.js